import { Grid } from "@mui/material";
import { CafeCard } from "./CafeCard";
import { useCafeViewStore } from "../../store/cafeViewStore";

export const CafeCardScroll = () => {
  const rows = useCafeViewStore(({ rows }) => rows);

  return (
    <Grid container direction="column">
      {rows.map(CafeCard)}
    </Grid>
  );
};
